/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback } from "react"
import { useSetRecoilState, useRecoilValue } from "recoil"
import { roomCallbackSelector, roomSelector } from "../../recoil/atoms/room"

function useHighQualityStreamSettings() {
  const setRoom = useSetRecoilState(roomSelector)
  const roomCallback = useRecoilValue(roomCallbackSelector)

  const meetingClient = useCallback(() => {
    return window.MeetOnline.client()
  }, [])

  const getRoomData = useCallback(async () => {
    return roomCallback.handleReturnData()
  }, [])

  const setEnableHighQualityStream = useCallback(
    async (enableHighQualityStream: boolean) => {
      if (enableHighQualityStream === undefined) return
      setRoom({
        name: "UPDATE",
        attributes: { enableHighQualityStream }
      })

      const room = await getRoomData()
      if (enableHighQualityStream) {
        // set all the setting value
        if (room.audienceBuffering !== undefined)
          meetingClient().rtc?.setAudienceMode(room.audienceBuffering)
        if (room.streamingResolution !== undefined)
          meetingClient().rtc.setStreamingResolution(room.streamingResolution)
      } else {
        // set all setting value to default
        meetingClient().rtc?.setAudienceMode(true)
        meetingClient().rtc.setStreamingResolution(0)
      }
    },
    []
  )

  const setAudienceBuffering = useCallback(
    async (audienceBuffering: boolean) => {
      if (audienceBuffering === undefined) return
      setRoom({
        name: "UPDATE",
        attributes: {
          audienceBuffering
        }
      })
      const room = await getRoomData()
      if (room.enableHighQualityStream) {
        // change the audience role if enableHighQualityStream
        meetingClient().rtc?.setAudienceMode(audienceBuffering)
      }
    },
    []
  )

  const setStreamingResolution = useCallback(
    async (streamingResolution: number) => {
      if (streamingResolution === undefined) return
      setRoom({
        name: "UPDATE",
        attributes: {
          streamingResolution
        }
      })
      const room = await getRoomData()
      if (room.enableHighQualityStream) {
        meetingClient().rtc.setStreamingResolution(streamingResolution)
      }
    },
    []
  )

  const setRtmpStreamEnable = useCallback((rtmpStreamEnable: boolean) => {
    if (rtmpStreamEnable === undefined) return
    setRoom({
      name: "UPDATE",
      attributes: {
        rtmpStreamEnable
      }
    })
  }, [])

  return {
    setEnableHighQualityStream,
    setAudienceBuffering,
    setStreamingResolution,
    setRtmpStreamEnable
  }
}

export default useHighQualityStreamSettings
